import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined'
import { TextField, Box, Typography, Tooltip, type TextFieldProps, type TypographyProps } from '@mui/material'
import { forwardRef, type ReactNode, type ForwardedRef } from 'react'
import { AsteriskRed } from '../AsteriskRed/AsteriskRed'
export type InputProps = TextFieldProps & {
  required?: boolean
  label?: ReactNode
  value?: number | string
  noTitle?: boolean
  tooltipText?: ReactNode
  errorMessage?: ReactNode
  errorMessageProps?: TypographyProps
}

export const Input = forwardRef(function Input(
  { label, required, noTitle, tooltipText, errorMessage, errorMessageProps, ...props }: InputProps,
  ref: ForwardedRef<unknown>,
) {
  return (
    <Box>
      {!noTitle && (
        <Box>
          <Typography fontSize="14px" mb={0.5}>
            {label || <>&nbsp;</>}
            {required && <AsteriskRed />}
            <>&nbsp;</>
            {tooltipText && (
              <Tooltip title={tooltipText}>
                <HelpOutlineOutlinedIcon fontSize="small" />
              </Tooltip>
            )}
          </Typography>
        </Box>
      )}
      <TextField
        inputRef={ref}
        size="small"
        placeholder="請輸入"
        variant="outlined"
        {...props}
      />
      {errorMessage && <Typography mt={0.5} color="red" fontSize="small" {...errorMessageProps}>{errorMessage}</Typography>}
    </Box>
  )
})
